import React from 'react';
import { FileText, Users, Calendar, MessageSquare, Star, Package } from 'lucide-react';
import { SurveyQuestionNew } from './SurveyQuestionNew';
import type { SurveySection as SurveySectionType } from '../../types/surveys/publicSurvey.types';

interface SurveySectionProps {
  section: SurveySectionType;
  primaryColor: string;
}

const iconMap: { [key: string]: React.FC<any> } = {
  'file-text': FileText,
  'users': Users,
  'calendar': Calendar,
  'message-square': MessageSquare,
  'star': Star,
  'package': Package,
};

export const SurveySection: React.FC<SurveySectionProps> = ({ section, primaryColor }) => {
  const Icon = section.icon ? iconMap[section.icon] : null;

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      {(section.title || section.sectionDescription) && (
        <div className="border-b border-gray-200 p-6">
          <div className="flex items-start">
            {Icon && (
              <div
                className="p-2 rounded-lg mr-4"
                style={{ backgroundColor: `${primaryColor}20` }}
              >
                <Icon
                  size={24}
                  style={{ color: primaryColor }}
                />
              </div>
            )}
            <div className="flex-1">
              {section.title && (
                <h3 className="text-lg font-semibold text-gray-900">{section.title}</h3>
              )}
              {section.sectionDescription && (
                <div
                  className="mt-1 text-sm text-gray-600"
                  dangerouslySetInnerHTML={{ __html: section.sectionDescription }}
                />
              )}
            </div>
          </div>
        </div>
      )}

      <div className="p-6 space-y-6">
        {section.questions.map((question) => (
          <SurveyQuestionNew
            key={question.id}
            question={question}
            primaryColor={primaryColor}
          />
        ))}
      </div>
    </div>
  );
};